import type { TDynamicData } from '@eliadmin/core/src/api/dynamics/dynamics-api';

/** One public selection shared by all partner rails and catalogue navigations. */
export function partnersQueryOptions(locale: string) {
  return {
    queryKey: [
      'saprem-partners-v1',
      process.env.NEXT_PUBLIC_API_URL ?? '',
      process.env.NEXT_PUBLIC_CURRENT_STORE ?? '',
      locale,
    ],
    staleTime: 5 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: false,
    queryFn: async ({ signal }: { signal: AbortSignal }): Promise<TDynamicData[]> => {
      const response = await fetch(`/api/partners?${new URLSearchParams({ locale })}`, {
        headers: { Accept: 'application/json' },
        signal,
      });
      if (!response.ok) throw new Error('Partners are temporarily unavailable.');
      const payload = (await response.json()) as { data?: TDynamicData[] };
      if (!Array.isArray(payload.data)) throw new Error('Invalid partners response.');
      return payload.data;
    },
  };
}
